import List from '../../components/List/List';
import { categories } from '../../utils/cardInfo';

const EventsPage = () => {
  return (
    <List
      category={'events'}
      heading={'Events'}
      cardHeader={categories.events.cardHeader}
      icons={categories.events.icons}
      dotColor={categories.events.dotColor}
    />
  );
};

export default EventsPage;
